import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import {
  fetchRawMaterials,
  fetchRawMaterial,
  createRawMaterials,
  updateRawMaterial,
  deleteRawMaterial,
  deleteManyRawMaterials,
  parsePackingList,
  assignRawMaterial,
  releaseRawMaterial
} from '../api/rawMaterialsApi.js';

export function useRawMaterials(filters = {}) {
  return useQuery({
    queryKey: ['raw-materials', 'list', filters],
    queryFn: () => fetchRawMaterials(filters),
    placeholderData: keepPreviousData,
    staleTime: 5 * 1000,
    refetchInterval: 10 * 1000
  });
}

export function useRawMaterial(id) {
  return useQuery({
    queryKey: ['raw-materials', 'detail', id],
    queryFn: () => fetchRawMaterial(id),
    enabled: !!id
  });
}

export function useCreateRawMaterials() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createRawMaterials,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['raw-materials'] })
  });
}

export function useUpdateRawMaterial() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: updateRawMaterial,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['raw-materials'] })
  });
}

export function useDeleteRawMaterial() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteRawMaterial,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['raw-materials'] })
  });
}

export function useDeleteManyRawMaterials() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteManyRawMaterials,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['raw-materials'] })
  });
}

export function useParsePackingList() {
  return useMutation({
    mutationFn: parsePackingList
  });
}

export function useAssignRawMaterial() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: assignRawMaterial,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['raw-materials'] })
  });
}

export function useReleaseRawMaterial() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: releaseRawMaterial,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['raw-materials'] })
  });
}
